var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shown),expression:"shown"}],staticClass:"preloader"},[_c('span',{staticClass:"circle-one"}),_c('span',{staticClass:"circle-two"}),_c('span',{staticClass:"circle-thr"})])}
var staticRenderFns = []

export { render, staticRenderFns }